export const services = [
  {
    slug: "frontend-engineering",
    title: "Frontend Engineering",
    shortDescription:
      "I build scalable React interfaces with reusable components, clean state flow, and maintainable architecture.",
    fullDescription:
      "I specialize in building production-ready React applications that scale with your product. From component architecture and state management to TypeScript integration and testing, I deliver interfaces that are maintainable, performant, and aligned with modern best practices.",
    features: [
      "React, Next.js, and TypeScript development",
      "Reusable component libraries and design systems",
      "State management with Redux or Context",
      "Clean, maintainable code architecture",
      "Integration with REST and GraphQL APIs",
    ],
    iconName: "CodeSlash",
  },
  {
    slug: "ui-ux-implementation",
    title: "UI/UX Implementation",
    shortDescription:
      "I convert Figma and design systems into responsive, accessible, and pixel-accurate interfaces across devices.",
    fullDescription:
      "I turn design mockups into polished, interactive interfaces. With strong attention to responsive layouts, accessibility standards, and cross-browser compatibility, I ensure your vision translates accurately from Figma to the browser.",
    features: [
      "Figma and design-system handoff",
      "Responsive, mobile-first layouts",
      "Accessibility (WCAG) compliance",
      "Pixel-accurate implementation",
      "Bootstrap, Material UI, and custom CSS",
    ],
    iconName: "Palette",
  },
  {
    slug: "performance-optimization",
    title: "Performance Optimization",
    shortDescription:
      "I improve Core Web Vitals with lazy loading, bundle hygiene, and rendering optimizations for faster experiences.",
    fullDescription:
      "I analyze and improve your app’s performance. Through code splitting, lazy loading, bundle optimization, and rendering improvements, I help you achieve better Core Web Vitals and a noticeably faster user experience.",
    features: [
      "Core Web Vitals optimization",
      "Code splitting and lazy loading",
      "Bundle size and asset optimization",
      "Rendering and re-render optimization",
      "Lighthouse and performance audits",
    ],
    iconName: "Speedometer2",
  },
];
